import store from 'app/store';
import { setConfigurations } from 'features/configurations';

// Structure refreshes that echo server-derived space data back into the
// store (sizing attributes after a save, generated windows, orientation
// exposures) are not user zoning edits. ResetDataWatcher only spares the
// configurations when they are replaced in the same render as the structure
// change, so the echo re-dispatches them inside its own synchronous batch.
// The copy is shallow: every signature-keyed consumer (autosave, the
// valid-systems watcher, option invalidation) sees identical content.
export function keepConfigurationsThroughStructureEcho(): void {
  const { configurations } = store.getState().configurations;
  if (configurations.length === 0) return;
  store.dispatch(setConfigurations([...configurations]));
}
